import React, { ReactNode, useState, RefObject } from "react";
import ReactSlick, { Settings } from "react-slick";
import styled from "styled-components";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
interface Props {
  children: ReactNode;
  hideArrow?: boolean;
  moreSettings?: any;
  sliderRef?: RefObject<ReactSlick>;
  variableWidth?: boolean;
  adaptiveHeight?: boolean;
  infinite?: boolean;
}

const Arrow = styled.img`
  object-fit: contain;
`;

const Carousel = ({
  children,
  hideArrow,
  sliderRef,
  variableWidth,
  adaptiveHeight,
  infinite,
}: Props) => {
  const [slideIndex, setSlideIndex] = useState(0);

  const settings: Settings = {
    dots: false,
    infinite: infinite ?? true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 10000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: hideArrow ? false : true,
    pauseOnHover: true,
    nextArrow: hideArrow ? undefined : (
      <Arrow alt={`next-index-${slideIndex + 1}`} width="20px" height="20px" />
    ),
    prevArrow: hideArrow ? undefined : (
      <Arrow alt={`next-index-${slideIndex - 1}`} width="20px" height="20px" />
    ),
    beforeChange: (_current, next) => setSlideIndex(next),
    variableWidth: variableWidth ? true : false,
    adaptiveHeight: adaptiveHeight ? true : false,
  };

  return (
    <ReactSlick ref={sliderRef} {...settings}>
      {children}
    </ReactSlick>
  );
};

export default Carousel;
